import * as EventConstants from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';
import FullScreenStore from 'nav/full-screen/FullScreenStore';
import {Organization} from 'orgs/OrganizationConstants';

class RegistryActivationFlowStore extends Store {
  organization!: Organization | null;
  isLoading!: boolean;

  resetState(): void {
    FullScreenStore.resetState();
    this.organization = null;
    this.isLoading = false;
  }

  getIsLoading(): boolean {
    return this.isLoading;
  }

  getOrganizationId(): string | null {
    return this.organization == null ? null : this.organization.id;
  }

  getOrganizationName(): string | null {
    return this.organization == null ? null : this.organization.name;
  }

  payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.REGISTRY_ACTIVATION_SET_ORGANIZATION:
        this.organization = action.organization;
        this.emitChange();
        break;

      case EventConstants.REGISTRY_ACTIVATION_SET_IS_LOADING:
        this.isLoading = true;
        this.emitChange();
        break;

      case EventConstants.ORG_CREATE_COMPLETED:
        this.organization = action.organization;
        this.isLoading = false;
        this.emitChange();
        break;

      case EventConstants.ORG_CREATE_FAILED:
        this.isLoading = false;
        this.emitChange();
        break;

      default:
        break;
    }
    return true;
  }
}

export default new RegistryActivationFlowStore(AppDispatcher);
